import { blockchainApi } from '../services/blockchainApi';
import type { AddressInfo } from '../types/blockchain.types';

interface ExplorerLinkProps {
  addressInfo: AddressInfo;
}

export function ExplorerLink({ addressInfo }: ExplorerLinkProps) {
  const explorerUrl = blockchainApi.getExplorerUrl(addressInfo.address, addressInfo.network);

  return (
    <div className="mt-6">
      <a
        href={explorerUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium shadow-sm hover:shadow-md"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          />
        </svg>
        View Full Report on {addressInfo.network.explorer_name}
      </a>
      <p className="mt-2 text-xs text-gray-500">
        Opens in new tab: {explorerUrl}
      </p>
    </div>
  );
}
